﻿import $ from "jquery";
import ko from "knockout";
import "ElementQueries";

import RootModel from "./RootModel";

export default function (model, options) {
	const element = $(`#${options.entryPointId} .ccs-logo`);

	if (element.length !== 0) {
		ko.applyBindings(new RootModel(model, options), element[0]);
	}
}
